import {
  ChatBotClient,
  IChatBotClient,
  ChatResponseDto,
  ResetResponseDto,
  DatasetDto,
  SendMessageCommand,
  ResetChatCommand,
  EndChatCommand,
} from "app/ApiClient";

const chatBotClient: IChatBotClient = new ChatBotClient(process.env.REACT_APP_API_URL);

export const getAvailableDatasets = async (): Promise<DatasetDto[]> => {
  return chatBotClient.getDataSets();
};

export const sendMessage = async (command: SendMessageCommand): Promise<ChatResponseDto> => {
  return chatBotClient.sendMessage(command);
};

export const resetSession = async (command: ResetChatCommand): Promise<ResetResponseDto> => {
  return chatBotClient.resetSession(command);
};

export const endSession = async (command: EndChatCommand): Promise<ResetResponseDto> => {
  return chatBotClient.endSession(command);
};
